import React from 'react';
import Menu from './Menu';
import PanelInfo from '../../labels/PanelInfo';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.inventory.actions';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.props.setInventoryWindow(0);
    }

    render() {
        return (
            <div className={'flex_full_row'}>
                <div className={'flex_full_row bg_ice_blue'}>
                    <div
                        className={
                            'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                        }
                        onScroll={this.handleScroll}
                    >
                        <Menu />
                    </div>
                    <PanelInfo id={'manage_aux_message'} />
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    undefined,
    mapDispatchToProps,
)(Index);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/Index.js